import React from 'react';
import { FadeInView } from '../ui/FadeInView';
export function ProblemSection() {
  return <section className="py-16 md:py-24 px-4 bg-[#1B4332] text-[#FAF7F2] text-center relative overflow-hidden" data-id="element-156">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-157">
        <FadeInView data-id="element-158">
          <h2 className="text-4xl md:text-6xl font-bold mb-10 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-159">
            Si quieres bajar de peso, déjame hacerte una pregunta honesta
          </h2>

          <div className="space-y-4 text-xl md:text-2xl font-medium text-[#FAF7F2]/90 mb-12 leading-relaxed" data-id="element-160">
            <p data-id="element-161">¿Te pasa que empiezas una dieta con motivación…</p>
            <p data-id="element-162">y a la semana ya estás cansado de seguirla?</p>
          </div>

          <div className="space-y-4 text-lg md:text-xl text-[#FAF7F2]/70 mb-12" data-id="element-163">
            <p data-id="element-164">No porque no tengas fuerza de voluntad.</p>
            <p data-id="element-165">No porque no quieras mejorar tu salud.</p>
            <p className="text-[#FAF7F2] font-medium text-xl md:text-2xl mt-6" data-id="element-166">
              <span className="bg-[#D4A853]/20 px-4 py-2 rounded-lg border border-[#D4A853]/30 inline-block" data-id="element-167">
                Sino porque la mayoría de las dietas son difíciles de mantener.
              </span>
            </p>
          </div>

          <div className="bg-[#2D5016] p-8 md:p-10 rounded-3xl border border-[#D4A853]/10 shadow-xl mb-12" data-id="element-168">
            <p className="md:text-xl mb-6 text-[#FAF7F2]/80 text-[16px]" data-id="element-169">
              Comidas complicadas. Recetas que llevan demasiado tiempo.
              Ingredientes caros o difíciles de conseguir.
            </p>
            <p className="text-2xl md:text-3xl font-bold text-[#D4A853]" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-170">
              Y al final terminas volviendo a lo mismo.
            </p>
          </div>

          <div className="mt-16" data-id="element-171">
            <h3 className="text-3xl md:text-4xl font-bold mb-8 text-[#D4A853]" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-172">
              El problema que nadie dice en voz alta
            </h3>

            <p className="text-xl mb-8 text-[#FAF7F2]/90" data-id="element-173">
              La mayoría de las dietas fracasan por tres razones:
            </p>

            <div className="flex flex-col items-center space-y-4 text-xl font-medium mb-10" data-id="element-174">
              <span className="flex items-center gap-3" data-id="element-175">
                <span className="text-[#D4A853]/60 text-sm" data-id="element-176">✕</span> son
                demasiado restrictivas
              </span>
              <span className="flex items-center gap-3" data-id="element-177">
                <span className="text-[#D4A853]/60 text-sm" data-id="element-178">✕</span> requieren
                demasiado tiempo
              </span>
              <span className="flex items-center gap-3" data-id="element-179">
                <span className="text-[#D4A853]/60 text-sm" data-id="element-180">✕</span> la comida
                es aburrida
              </span>
            </div>

            <p className="text-xl mb-6 text-[#FAF7F2]/80" data-id="element-181">
              Por eso muchas personas:
            </p>

            <div className="flex flex-col items-center space-y-3 text-lg text-[#FAF7F2]/70 mb-12" data-id="element-182">
              <p data-id="element-183">abandonan a la semana</p>
              <p data-id="element-184">vuelven a subir de peso</p>
              <p data-id="element-185">terminan frustradas</p>
            </div>

            <div className="bg-[#FAF7F2]/5 p-8 md:p-10 rounded-3xl border border-[#FAF7F2]/10" data-id="element-186">
              <p className="text-xl md:text-2xl font-medium mb-4 text-[#D4A853]" data-id="element-187">
                Y el problema no es tu falta de disciplina.
              </p>
              <p className="md:text-4xl font-bold text-[#FAF7F2] text-[20px]" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-188">
                El problema es que nadie te enseñó cómo comer rico y adelgazar
                al mismo tiempo.
              </p>
            </div>
          </div>
        </FadeInView>
      </div>
    </section>;
}